import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Modal from '../Modal/Modal';
import PromotionForm from './PromotionForm/PromotionForm';

import {
  PROMOTION_DURATION,
  PROMOTION_TYPE,
  PROMOTION_TYPE_AND_DURATION_TO_VALUE,
} from '../../constants/payment.constants';

import css from './PromotionModal.module.css';

export const getPromotionPlanType = selectedPlan => {
  if (!selectedPlan) return;

  const priorityList = [
    PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
    PROMOTION_TYPE.RECURRING.HIGHLIGHT,
    PROMOTION_TYPE.RECURRING.RECOMMENDED,
  ];

  return priorityList.find(type => selectedPlan.toLowerCase().includes(type.toLowerCase()));
};

export const getPromotionPlanDuration = selectedPlan =>
  Object.values(PROMOTION_DURATION).find(duration =>
    selectedPlan.toLowerCase().includes(duration.toLowerCase())
  );

const getInitialValues = promotion => {
  if (!promotion)
    return {
      duration: PROMOTION_DURATION.WEEKLY,
    };

  const { plan, nextPlan } = promotion;

  const selectedPlan = nextPlan ?? plan;

  const initialValues = {
    plan: getPromotionPlanType(selectedPlan),
    duration: getPromotionPlanDuration(selectedPlan),
  };

  return initialValues;
};

const PromotionModal = props => {
  const intl = useIntl();

  const {
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    listingId,
    scrollLayerClassName,
    promotion,
    promotionPrices,
    onPromote,
    listingPromotionInProgress,
    listingPromotionError,
    closeId = 'Modal.close',
  } = props;
  const handleSubmit = values => {
    const { plan, duration } = values;
    const finalPlan = PROMOTION_TYPE_AND_DURATION_TO_VALUE[plan][duration];
    onPromote(listingId, finalPlan);
  };
  const initialValues = getInitialValues(promotion);

  return (
    <Modal
      id="promotionModal"
      isOpen={isOpen}
      scrollLayerClassName={scrollLayerClassName}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      closeButtonMessage={intl.formatMessage({ id: closeId })}
      containerClassName={css.container}
      usePortal
    >
      {isOpen && (
        <PromotionForm
          formId="PromotionForm"
          initialValues={initialValues}
          promotionPrices={promotionPrices}
          onSubmit={handleSubmit}
          onCancel={onCloseModal}
          submitInProgress={listingPromotionInProgress}
          promotion={promotion}
        />
      )}
      <small className={css.error}>
        {listingPromotionError && (
          <FormattedMessage
            id={`Global.${promotion ? 'changing' : 'creating'}ListingPromotionError`}
          />
        )}
      </small>
    </Modal>
  );
};

export default PromotionModal;
